module.exports = __webpack_public_path__ + "static/media/2025_Sikuki_Nuuk_Harbour.df0655de.png";